export default {
    SEARCH: 'search',
    FILTER: 'filter',
    AGENDA: 'agenda',
};
